<template>
	<div class="flex flex-col items-center">
		<div>
			<span class="font-bold">{{ name }}</span>
			<span v-if="role">/ {{ role }}</span>
		</div>
		<a class="text-dj-red" :href="`mailto:${email}`">{{ email }}</a>
		<a class="text-dj-red" :href="`tel:${phone}`">{{ phone }}</a>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "ContactUsCard",
	props: {
		name: {
			type: String,
			default: "Name",
		},
		role: {
			type: String,
			default: "Role",
		},
		email: {
			type: String,
			default: "Email",
		},
		phone: {
			type: String,
			default: "Phone",
		},
	},
});
</script>
